<template>
  <div>
    <div class="apresentacao ui-container" v-if="actualEmpreendimento">
      <div class="container">
        <div class="row">
          <div class="col-xl-5 col-12">
            <div v-if="!actualEmpreendimento.internal_image" class="apresentacao__image ui-image--contain" :style="'background-image: url('+actualEmpreendimento.image+')'">
            </div>
            <div v-if="actualEmpreendimento.internal_image" class="apresentacao__image ui-image--cover" :style="'background-image: url('+actualEmpreendimento.internal_image+')'">
            </div>
          </div>
          <div class="col-xl-7 col-12">
            <div class="">
              <div class="apresentacao__image__title">
                <h1>
                  {{actualEmpreendimento.title}}
                </h1>
              </div>
              <div class="ui-description lh-36" v-html="actualEmpreendimento.description"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <InternaApresentacaoCaracteristicas :characteristics="actualEmpreendimento.characteristics"
    ></InternaApresentacaoCaracteristicas>
    <InternaApresentacaoDiferenciais :differentials="actualEmpreendimento.differentials"
    ></InternaApresentacaoDiferenciais>
  </div>
</template>
<script>
import InternaApresentacaoCaracteristicas from './InternaApresentacaoCaracteristicas'
import InternaApresentacaoDiferenciais from './InternaApresentacaoDiferenciais'
import { mapGetters } from 'vuex'
export default {
  components: {
    InternaApresentacaoCaracteristicas,
    InternaApresentacaoDiferenciais
  },
  computed: {
    ...mapGetters([
      'actualEmpreendimento'
    ])
  },
  created () {
    this.$store.dispatch('showEmpreendimento', this.$route.params.slug)
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/_variables.scss';
.apresentacao {
  &__image {
    min-height: 550px;
    &__title {
      margin-bottom: 50px;
      h1 {
        color: $yellow;
        font-weight: 900;
        text-transform: uppercase;
      }
    }
  }
  @media (max-width: 1700px) {
    &__col {
      flex: 0 0 80%;
      max-width: 80%;
    }
  }
  @media (max-width: 1450px) {
    &__col {
      flex: 0 0 90%;
      max-width: 90%;
    }
    &__container__col {
      padding: 40px 0;
    }
    &__image__title {
      margin-bottom: 20px;
    }
  }
  @media (max-width: 1200px) {
    &__image {
      background-position: center;
      min-height: 450px;
    }
    &__container {
      margin: 0 auto;
      max-width: 960px;
      padding-left: 15px;
      padding-right: 15px;
      text-align: center;
      width: 100%;
    }
    &__col {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
  @media (max-width: 991px) {
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 767px) {
    &__image__title {
      h1 {
        font-size: 30px;
      }
    }
  }
  @media (max-width: 575px) {
    &__image {
      background-position: center;
      min-height: 300px;
      margin-bottom: 20px;
    }
    &__image__title {
      h1 {
        font-size: 26px;
      }
    }
    &__container__col {
      padding-top: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/empreendimentos/InternaApresentacao.vue